<template lang="html">
  <div class="container">
    <div class="login-index">
      <img src="../../assets/login_logo.png" width="70%" class="login-logo"/>
      <van-field
          v-model="username"
          required
          clearable
          label="用户名"
          placeholder="请输入用户名"
          style="margin-top: .8rem"
      />
      <van-field
          v-model="password"
          required
          clearable
          type="password"
          label="密码"
          placeholder="请输入密码"
          style="margin-top: .6rem"
      />
      <van-button @click="login" class="f-w" type="primary">登录</van-button>
    </div>
  </div>
</template>

<script>
import md5 from 'js-md5';
import { setToken, setOpenId, getOpenId } from "../../utils/auth";
import website from "../../utils/website";

export default {
  data () {
    return {
      username: '',
      password: '',
      openid: '',
    }
  },
  mounted() {
    this.openid = getOpenId();
    const code = window.localStorage.getItem('code')
    if (code){
      const params = {
        code: code
      };
      this.init(params);
    } else {
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${website.appid}&redirect_uri=${website.domain}/wechat/login&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
    }

  },
  methods: {
    init(params){
      this.$api.wechat.getWxUser(params).then((res) => {
        if (res && res.code === 200){
          this.openid = res.data.openid;
          setOpenId(this.openid);
          this.getWechatUserToken(this.openid);
        } else if (res.code === 400){
          window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${website.appid}&redirect_uri=${website.domain}/wechat/login&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
        }
      });
    },
    getWechatUserToken(openId){
      this.$api.wechat.getToken({
        grant_type: 'wechat',
        tenantId: '000000',
        openid: openId
      }).then((res) => {
        if (res.access_token){
          window.localStorage.removeItem('code');
          setToken(res.access_token);
          window.localStorage.setItem('user', JSON.stringify(res))
          this.$notify({ type: 'success', message: '登录成功'});
          this.$router.push({
            path: '/wechat/home'
          })
        }
      })
    },
    login() {
      if (this.username === ''){
        this.$notify({ type: 'danger', message: '请输入用户名' });
        return;
      }
      if (this.password === ''){
        this.$notify({ type: 'danger', message: '请输入密码' });
        return;
      }
      const params = {
        openid: this.openid,
        username: this.username,
        password: md5(this.password)
      }
      this.$api.wechat.wxUserLogin(params).then((res) => {
        window.localStorage.removeItem('code');
        if (res.code !== 200){
          this.$notify({ type: 'danger', message: res.msg });
        } else {
          if (!res.data.access_token){
            this.$notify({ type: 'danger', message: '用户名或者密码错误' });
            return;
          }
          setToken(res.data.access_token);
          window.localStorage.setItem('user', JSON.stringify(res.data))
          this.$notify({ type: 'success', message: res.msg });
          this.$router.push({
            path: '/wechat/home'
          })
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
.f-w {
  width: 100%;
  margin-top: .8rem;
}
.container {
  background-color: #ffffff;
}
.login-index {
  position: absolute;
  top: 25%;
  left: 7%;
}
.login-logo {
  text-align: center;
  margin-left: 1rem;
}
</style>
